export const SET_PROJECT_FILTER_TAB = "SET_PROJECT_FILTER_TAB";
export const SET_PROJECT_DETAILS_TAB = "SET_PROJECT_DETAILS_TAB";
export const SET_PROJECT_DETAILS_CASE_TAB = "SET_PROJECT_DETAILS_CASE_TAB";
export const DROP_D0WNS = "DROP_D0WNS";
export const COUNTRIES_LIST = "COUNTRIES_LIST";
export const META_DATA = "META_DATA";
export const SITE_DATA = "SITE_DATA";
export const IS_DIRTY = "IS_DIRTY";
export const IS_DENTAL_RECORD_SCREEN = "IS_DENTAL_RECORD_SCREEN";
export const EDIT_PROJECT_STATUS = "EDIT_PROJECT_STATUS";
export const EDIT_CASE_STATUS = "EDIT_CASE_STATUS";
export const CASES_ACTIVE_TAB = "CASES_ACTIVE_TAB";
export const SET_MY_ORGANIZATION = "SET_MY_ORGANIZATION";
export const SET_MY_INFO = "SET_MY_INFO";
export const SET_PROJECT_STATUS = "SET_PROJECT_STATUS";

export const _setProjectTab = (value) => {
  return (dispatch) => {
    dispatch({
      type: SET_PROJECT_FILTER_TAB,
      payload: value,
    });
  };
};
export const _setProjectDetailsTab = (value) => {
  return (dispatch) => {
    dispatch({
      type: SET_PROJECT_DETAILS_TAB,
      payload: value,
    });
  };
};
export const _setProjectDetailsCaseTab = (value) => {
  return (dispatch) => {
    dispatch({
      type: SET_PROJECT_DETAILS_CASE_TAB,
      payload: value,
    });
  };
};
export const _getDentalIdentificationDropdowns = (data) => {
  return (dispatch) => {
    dispatch({
      type: DROP_D0WNS,
      payload: data,
    });
  };
};
export const _getCountriesList = (data) => {
  return (dispatch) => {
    dispatch({
      type: COUNTRIES_LIST,
      payload: data,
    });
  };
};
export const _getMetaData = (data) => {
  return (dispatch) => {
    dispatch({
      type: META_DATA,
      payload: data,
    });
  };
};
export const _getSiteData = (data) => {
  return (dispatch) => {
    dispatch({
      type: SITE_DATA,
      payload: data,
    });
  };
};

export const _onToogleIsDirty = (toggle) => {
  return (dispatch) => {
    dispatch({
      type: IS_DIRTY,
      payload: toggle,
    });
  };
};
export const _onDentalRecordScreen = (toggle) => {
  return (dispatch) => {
    dispatch({
      type: IS_DENTAL_RECORD_SCREEN,
      payload: toggle,
    });
  };
};

export const _toggleEditProjectState = (status) => {
  return (dispatch) => {
    dispatch({
      type: EDIT_PROJECT_STATUS,
      payload: status,
    });
  };
};
export const _toggleEditCaseState = (status) => {
  return (dispatch) => {
    dispatch({
      type: EDIT_CASE_STATUS,
      payload: status,
    });
  };
};
export const _toogleCasesActiveTab = (status) => {
  return (dispatch) => {
    dispatch({
      type: CASES_ACTIVE_TAB,
      payload: status,
    });
  };
};
export const _setMyOrganizationData = (data) => {
  return (dispatch) => {
    dispatch({
      type: SET_MY_ORGANIZATION,
      payload: data,
    });
  };
};

export const _setMyInfo = (data) => {
  return (dispatch) => {
    dispatch({
      type: SET_MY_INFO,
      payload: data,
    });
  };
};
export const _setisProjectOpenForCollaboration = (toggle) => {
  return (dispatch) => {
    dispatch({
      type: SET_PROJECT_STATUS,
      payload: toggle,
    });
  };
};
